module.exports = __webpack_public_path__ + "static/media/credit-card.bd53ccd1.svg";